<template>
  <div>
    <b-form-tags
      :value="value"
      :disabled="disabled"
      :placeholder="placeholder"
      :state="required && (!value || value.length === 0) ? false : null"
      separator=","
      tag-variant="info"
      remove-on-delete
      add-button-text="Tambah"
      duplicate-tag-text="Jurusan sudah ada"
      @input="onInput"
    ></b-form-tags>
    <small class="text-muted">Pisahkan dengan Enter atau koma.</small>
  </div>
</template>

<script>
export default {
  name: 'HelperJurusanInput',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: 'Ketik nama jurusan lalu Enter',
    },
  },
  methods: {
    onInput(val) {
      this.$emit(
        'input',
        (val || []).map((v) => String(v).trim()).filter((v) => v !== '')
      )
    },
  },
}
</script>
